import React from 'react';
import AcquireWebComponent from '../../framework/MaterialUI';
import { FullRow, Row, Col } from '../../framework/Grid';
import isEmpty from 'lodash/isEmpty';

import Dialog from 'material-ui/Dialog';
import Error from 'material-ui/svg-icons/alert/error';

class LimitExceededForm extends AcquireWebComponent {
	constructor(props) {
		super(props);
		this.state = {
			comments: "",
			subject: ""
		}
	}

	render() {
		const { showSaveErrorDialog, showSuccessForm, openContactForm, history, roleId, openContactFormClick, 
			onContactFormSubmit, send_assist_request_error} = this.props;
		const actionButtons = [
			send_assist_request_error &&
			<div className="pull-left ml-20 mt-5" style={{fontWeight:"bold", color:"#FF0000"}}>
				{send_assist_request_error}
			</div>,
			<button onClick={(e)=>{e.preventDefault();history.push("/segments/list/active")}} className="btn btn-default btn-aa-info mr-10">Cancel</button>,
			(isEmpty(this.state.comments) || isEmpty(this.state.subject)) ?
			<button disabled className="btn btn-default btn-aa-info mr-10">Submit</button> :
			<button onClick={(e) =>{onContactFormSubmit(e, this.state.subject, this.state.comments)}} className="btn btn-aa-default mr-10">Submit</button>
		]

 		return (
			<div>
				<Dialog open={showSaveErrorDialog} style={{top: '-1.8em'}} modal={true} contentStyle={{width:"500px"}} bodyStyle={{width:"500px", padding:"20px"}}
					overlayStyle={{opacity: 0.9, backgroundColor:'#666666'}}>
					<Row className="no-margin no-padding-top no-padding-right" key="content-row"
						style={{fontSize:'16px', color:"#000", fontFamily:"Arial"}}>
						<Col xs="12" sm="12" md="12" lg="12" className="no-padding-right">
							<Error style={{ position:"absolute", left:"-20px" }} color="#FF0000" />
							<strong key="error-text">You have reached your saved audience segment limit for the Basic subscription tier. In order to save more segments, you must upgrade your account. {roleId >= 51 && [<a key="btn-open-contact-form" className="contact-request-link" onClick={openContactFormClick.bind(this)} href="#">Click here</a>, " to contact your client services representative to discuss upgrading your account."]}</strong>
						</Col>
					</Row>
					<FullRow className="no-margin no-padding text-center" key="button-row">
						<button type="button" onClick={()=>{history.push("/segments/list/active")}} className="btn btn-default btn-aa-info">Cancel</button>
					</FullRow>
				</Dialog>
				<Dialog open={showSuccessForm}
					contentStyle={{width:"350px", padding:'20px'}}
					modal={true}>
					<div style={{fontSize:'16px', fontFamily:"Arial", color:"#000"}} className="text-center">Your message has been sent.</div>
					<div className="text-center mt-20">
						<button className="btn btn-aa-default" onClick={()=>{history.push("/segments/list/active")}} >CLOSE</button>
					</div>
				</Dialog>
				<Dialog open={openContactForm}
					contentStyle={{width:"540px"}}
					titleClassName={"support-form-title"}
					bodyClassName={"support-form-body"}
					actionsContainerClassName={"support-form-action-container"}
					title={"CONTACT US"}
					modal={true} actions={actionButtons}>
					<Row className="no-padding-left no-padding-right no-padding-bottom pt-10 no-margin-bottom">
						<Col xs="3" sm="3" md="3" lg="3" className="pt-10"><strong>Subject</strong></Col>
						<Col xs="9" sm="9" md="9" lg="9">
							<input type="text" style={{width:"100%"}} value={this.state.subject} maxLength="65"
								onChange={(e)=>{this.setState({subject:e.target.value})}} />
						</Col>
					</Row>
					<Row className="no-padding-left no-padding-right no-padding-bottom no-margin-bottom">
						<Col xs="3" sm="3" md="3" lg="3" className="pt-10"><strong>Comments</strong></Col>
						<Col xs="9" sm="9" md="9" lg="9">
							<textarea className="comment-box" value={this.state.comments} maxLength="500"
								onChange={(e)=>{this.setState({comments:e.target.value})}} />
						</Col>
					</Row>
				</Dialog>				
			</div>
		);
	}
}

LimitExceededForm.defaultProps = {
	showSaveErrorDialog: false,
	showSuccessForm: false,
	openContactForm: false
}
export default LimitExceededForm





// WEBPACK FOOTER //
// ./src/components/Segment/Forms/LimitExceeded.jsx